// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.v-application .spinner-border.white {\n  color: #fff !important;\n  border: 0.25em solid #fff !important;\n  border-right-color: transparent !important;\n  background-color: transparent !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
